const VOICE_GENERIC_MESSAGE = 'Voice calling is temporarily unavailable. Please try again.';
const VOICE_TOKEN_MESSAGE = 'Voice calling is temporarily unavailable. Please refresh and try again.';
const VOICE_AUDIO_DEVICE_MESSAGE = 'Your selected audio device is unavailable. Please choose another microphone or speaker.';

function getErrorCode(error: unknown): number | null {
  const rawCode = (error as { code?: unknown } | null)?.code;
  if (typeof rawCode === 'number' && Number.isFinite(rawCode)) {
    return rawCode;
  }
  if (typeof rawCode === 'string' && rawCode.trim().length > 0) {
    const parsed = Number(rawCode);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

function getErrorMessage(error: unknown): string {
  const message = (error as { message?: unknown } | null)?.message;
  return typeof message === 'string' ? message : '';
}

export function isVoiceTokenError(error: unknown): boolean {
  const code = getErrorCode(error);
  if (code === 20101 || code === 20103 || code === 20104) {
    return true;
  }

  const message = getErrorMessage(error).toLowerCase();
  return message.includes('access token') || message.includes('token expired');
}

export function getVoiceErrorMessage(error: unknown): string {
  if (isVoiceTokenError(error)) {
    return VOICE_TOKEN_MESSAGE;
  }

  const message = getErrorMessage(error).toLowerCase();
  if (message.includes('device not found')) {
    return VOICE_AUDIO_DEVICE_MESSAGE;
  }

  return VOICE_GENERIC_MESSAGE;
}
